import { constant, toastCutomId, LocalStorage } from "./Constant";
var moment = require("moment"); //this supporting es5 format

export const isEmpty = (value) => {
  if (!value) return true;
  if (Array.isArray(value)) return !value.length;
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
};

export const updateState = (event, state, objErrors) => {
  const field = event.target.name;
  let val = event.target.value;
  let LocalState = state;
  let LocalErrors = objErrors;
  LocalState[field] = val;
  if (val.trim().length > 0) {
    LocalErrors[field] = "";
  }
  return LocalState;
};

export const setDateFormat = (DOB) => {
  return moment(DOB);
};

export const updateDropDownState = (event, data, objErrors) => {
  objErrors[data.name] = "";
  for (let i = 0; i < data.options.length; i++) {
    if (data.value === data.options[i].value) {
      return data.options[i].key;
    }
  }
  return "";
};

export const updateDateState = (name, date, state, objErrors) => {
  const field = name;
  let LocalState = state;
  LocalState[field] = date;
  if (date == null) objErrors[field] = "Required field";
  else objErrors[field] = "";
  return LocalState;
};

export const validateRegex = (regex, value) => {
  return regex.test(value);
};

export const inputErrorClass = (error) => {
  if (error !== undefined) return error.length === 0 ? "" : "error";
  else return "";
};

export const validateName = (value) => {
  return (
    value &&
    value.length > 1 &&
    value.length < 50 &&
    validateRegex(constant.AlphaRegEx, value)
  );
};

export const validateDescription = (value) => {
  return (
    value &&
    value.length < 50 &&
    validateRegex(constant.AlphaPlusSomeSpecialCharRegex, value)
  );
};
export const getAuthenticationToken = () => {
  let userInfo = localStorage.userInfo;
  if (!isEmpty(userInfo)) {
    let userInfoObj = JSON.parse(userInfo);
    return userInfoObj.token.access_token;
  } else {
    return "";
  }
};
export const getSelectedCompany = () => {
  let compInfo = localStorage.selectedCompany;

  if (!isEmpty(compInfo)) {
    let compInfoObj = JSON.parse(compInfo);
    return compInfoObj;
  } else {
    return "";
  }
};
export const getSelectedOffice = () => {
  // First check sessionStorage (persists during browser session)
  let officeInfo = sessionStorage.getItem("selectedOffice");

  // If not in sessionStorage, check localStorage (persists across sessions)
  if (isEmpty(officeInfo)) {
    officeInfo = localStorage.getItem("selectedOffice");
    // If found in localStorage, also save to sessionStorage for consistency
    if (!isEmpty(officeInfo)) {
      sessionStorage.setItem("selectedOffice", officeInfo);
    }
  }

  if (!isEmpty(officeInfo)) {
    let officeInfoObj = JSON.parse(officeInfo);
    return officeInfoObj;
  } else {
    return "";
  }
};
export const getCurrentEmployee = () => {
  let currentEmployee = localStorage.currentEmployee;
  if (!isEmpty(currentEmployee)) {
    let currentEmployeeObj = JSON.parse(currentEmployee);
    return currentEmployeeObj;
  } else {
    return "";
  }
};
export const getEditDep = () => {
  let dep = localStorage.editDep;

  if (!isEmpty(dep)) {
    let depObj = JSON.parse(dep);
    return depObj;
  } else {
    return "";
  }
};
export const getEditSkill = () => {
  let skill = localStorage.editSkill;

  if (!isEmpty(skill)) {
    let skillObj = JSON.parse(skill);
    return skillObj;
  } else {
    return "";
  }
};
export const getIsEditKey = () => {
  let key = localStorage.isEditView;

  if (!isEmpty(key)) {
    let keyObj = JSON.parse(key);
    return keyObj;
  } else {
    return "";
  }
};
export const getYearLeaves = () => {
  let Info = localStorage.yearEmpLeaves;

  if (!isEmpty(Info)) {
    let InfoObj = JSON.parse(Info);
    return InfoObj;
  } else {
    return "";
  }
};
export const getEmployeeId = () => {
  let Info = localStorage.EmployeeId;

  if (!isEmpty(Info)) {
    let InfoObj = JSON.parse(Info);
    return InfoObj;
  } else {
    return "";
  }
};
export const getleaveTypes = () => {
  let Info = localStorage.leaveTypes;

  if (!isEmpty(Info)) {
    let InfoObj = JSON.parse(Info);
    return InfoObj;
  } else {
    return "";
  }
};
export const clearSelectedOffice = () => {
  localStorage.removeItem(LocalStorage.selectedOffice);
  sessionStorage.removeItem("selectedOffice");
};
export const clearYearLeaves = () => {
  localStorage.removeItem(LocalStorage.yearEmpLeaves);
  localStorage.removeItem(LocalStorage.leaveTypes);
  localStorage.removeItem(LocalStorage.employeeId);
};
export const clearSelectedComp = () => {
  localStorage.removeItem(LocalStorage.selectedCompany);
  localStorage.removeItem("superAdminInCompany");
};
export const clearCurrentEmployee = () => {
  localStorage.removeItem(LocalStorage.currentEmployee);
};
export const clearSelectedCompAndOffice = () => {
  localStorage.removeItem(LocalStorage.selectedCompany);
  localStorage.removeItem(LocalStorage.selectedOffice);
  localStorage.removeItem("superAdminInCompany");
};
export const clearLocalStorageItem = (key) => {
  localStorage.removeItem(key);
};
export const checkEducationRecord = (arrayvar, state) => {
  if (state.DegreeName === "") {
    return true;
  } else {
    for (let i = 0; i < arrayvar.length; i++) {
      if (arrayvar[i].DegreeName === state.DegreeName) {
        return true;
      }
    }
  }
  return false;
};
export const checkFamilyRecord = (arrayvar, state) => {
  if (state.FirstName === "" && state.LastName === "") {
    return true;
  } else {
    for (let i = 0; i < arrayvar.length; i++) {
      if (
        (arrayvar[i].FirstName === state.FirstName &&
          arrayvar[i].LastName === state.LastName) ||
        arrayvar[i].CNIC === state.CNIC
      ) {
        return true;
      }
    }
  }
  return false;
};
export const checkSkillRecord = (arrayvar, state) => {
  if (state.SkillName === "") {
    return true;
  } else {
    for (let i = 0; i < arrayvar.length; i++) {
      if (arrayvar[i].SkillName === state.SkillName) {
        return true;
      }
    }
  }
  return false;
};
export const checkWorkHistoryRecord = (arrayvar, state) => {
  if (state.Organisation === "") {
    return true;
  } else {
    for (let i = 0; i < arrayvar.length; i++) {
      if (arrayvar[i].Organisation === state.Organisation) {
        return true;
      }
    }
  }
  return false;
};
export const removeSpace = (str) => {
  if (str !== undefined) {
    let res = str.replace(/\s/g, "");
    return res;
  }
};

export const validateOnlyAphabetsInput = (data, objErrors, isValidForm) => {
  for (var property in data) {
    if (data.hasOwnProperty(property)) {
      if (property === "companyId") {
        continue;
      }
      if (property !== "Id") {
        if (
          typeof data[property] !== "boolean" &&
          typeof data[property] !== "number"
        ) {
          let val = data[property];
          if (val.trim().length === 0) {
            objErrors[property] = "required field";
            isValidForm = false;
          } else if (property === "Name" || property === "Location") {
            let isValid = validateRegex(constant.AlphaRegEx, data[property]);
            if (!isValid) {
              objErrors[property] = "only alphabets allowed";
              isValidForm = isValid;
            }
          } else {
            objErrors[property] = "";
          }
        }
      }
    }
  }
  let result = {
    objErrors: objErrors,
    isValidForm: isValidForm,
  };
  return result;
};

export const validateForm = (state, self) => {
  self.setState({
    isValidForm: self.state.isValidName && self.state.isValidNotes,
  });
};
export const validateInput = (fieldName, value, state, self) => {
  let { FormErrors, isValidName, isValidNotes } = self.state;
  switch (fieldName) {
    case "Name":
      isValidName = validateName(value);
      FormErrors.Name = isValidName ? "" : "Invalid  Name";
      break;
    case "Notes":
      isValidNotes = validateDescription(value);
      FormErrors.Notes = isValidNotes ? "" : "Invalid Description";
      break;
    default:
      break;
  }
  self.setState({ FormErrors, isValidName, isValidNotes }, () =>
    validateForm(state, self)
  );
};

export const inputErrorClasss = (error) => {
  return error.length === 0 ? "" : "error field";
};
export const validateSalaryInfo = (data, objErrors, isValidForm) => {
  for (var property in data) {
    if (data.hasOwnProperty(property)) {
      if (property !== "Id") {
        let val = data[property];
        if (typeof data[property] !== "number") val = val.trim();
        if (val.length === 0) {
          objErrors[property] = "required field";
          isValidForm = false;
        } else if (property === "Salary") {
          if (val === 0) {
            objErrors[property] = "required field";
            isValidForm = false;
          } else {
            let isValid = validateRegex(constant.NumRegex, data[property]);
            if (!isValid) {
              objErrors[property] = "only numbers allowed";
              isValidForm = isValid;
            }
          }
        } else {
          objErrors[property] = "";
        }
      }
    }
  }
  let result = {
    objErrors: objErrors,
    isValidForm: isValidForm,
  };
  return result;
};

export const GetCompAndOffice = () => {
  let company = getSelectedCompany();
  let office = getSelectedOffice();
  if (!isEmpty(company) && !isEmpty(office)) {
    let resComp = removeSpace(company.name.toLowerCase());
    let resOffice = removeSpace(office.name.toLowerCase());
    let link = `/${resComp + "/" + resOffice}`;
    return link;
  } else {
    return "/";
  }
};
